export default {
	"order.ExchangeSuccessfully": "兌換成功",
	"order.NoActivationAddress": "無激活地址！"
}